import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import SaltDashboard from '../SaltDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import SaltPageImpl from './SaltPageImpl';

export default function SaltPage() {
    const dispatch = useDispatch();
    const { saltList} = useSelector((state)=>state.pharmaslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < SaltPageImpl />
    )

}